const SHOWN_KEY = 'fontLoadWarningShown'

export type FontLoadWarningSession = {
  shown: () => boolean
  markShown: () => void
}

/**
 * Whether the font-load warning has shown in this browser session. The flag
 * lives in `storage` (the tab's sessionStorage), so it holds across remounts
 * and reloads in the tab. `storage` is read on every call, since reaching it
 * can throw, as can its reads and writes (private mode, a sandboxed frame);
 * this instance's own flag then keeps the warning to one showing per page
 * load.
 */
export const createFontLoadWarningSession = (
  storage: () => Storage,
): FontLoadWarningSession => {
  let shownHere = false
  return {
    shown: () => {
      if (shownHere) return true
      try {
        return storage().getItem(SHOWN_KEY) === 'true'
      } catch {
        return false
      }
    },
    markShown: () => {
      shownHere = true
      try {
        storage().setItem(SHOWN_KEY, 'true')
      } catch {
        // shownHere holds the flag for this page load.
      }
    },
  }
}

export const fontLoadWarningSession = createFontLoadWarningSession(
  () => window.sessionStorage,
)
